const DefaultRedirectsFormState = {
    payload: {
        domain_id: '',
        all_domains: '',
        regex: '',
        destination:'',
        redirect_code:''
    },
    errors: [],
    errorsPresent: false,
    submitted: false,
    dispatchAPI: false,
    mode: `create`,
    message: ``,
    site_id: ``,
};

export const RedirectsFormState = {data: DefaultRedirectsFormState};